const {body} = document
const WIDTH = 992 // refer to Bootstrap's responsive design

export default {
  watch: {
    $route (route) {

    }
  },
  beforeMount () {
    window.addEventListener('resize', this.$_resizeHandler)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.$_resizeHandler)
  },
  mounted () {
    const isMobile = this.$_isMobile()
    if (isMobile < WIDTH) {
      this.$store.dispatch('user/changeDevice','mobile')
    } else if (992 < isMobile && isMobile < 1200) {
      this.$store.dispatch('user/changeDevice','integrated')
    } else {
      this.$store.dispatch('user/changeDevice','desktop')
    }

  },
  methods: {
    // use $_ for mixins properties
    // https://vuejs.org/v2/style-guide/index.html#Private-property-names-essential
    $_isMobile () {
      const rect = body.getBoundingClientRect()
      return rect.width - 1
    },
    $_resizeHandler () {
      if (!document.hidden) {
        const isMobile = this.$_isMobile()
        if (isMobile < WIDTH) {
          this.$store.dispatch('user/changeDevice','mobile')
        } else if (992 < isMobile && isMobile < 1200) {
          this.$store.dispatch('user/changeDevice','integrated')
        } else {
          this.$store.dispatch('user/changeDevice','desktop')
        }
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/index/mixin/ResizeHandler.js
